
// Layout
import Main from "../../../components/layout/Main";

// Class
import { PreviewCode } from "../../../components/elements/PreviewCode";

// Component
import BoxCode from "../../../components/elements/BoxCode";
import Button from "../../../components/elements/Button";
import Col from "../../../components/elements/Table/Col";
import Row from "../../../components/elements/Table/Row";
import Table from "../../../components/elements/Table/Table";


export default function Tablas() {

    const code = `
import Table from "../../../components/elements/Table/Table";
import Row from "../../../components/elements/Table/Row";
import Col from "../../../components/elements/Table/Col";

export default function TablaExample() {
    return (
        <Table>
                        <Row type='header'>
                                <Col priority='alta' type='number' order={true}>ID</Col>
                                <Col priority='alta' order={true} filter={[true, 'text', 'Buscar Palabra']} max={50}>Default (Texto)</Col>
                                <Col priority='media' type='numero' filter={[true]}>Numero</Col>
                                <Col type='money' size={200}>Money</Col>
                                <Col priority='media' type='icon'>Icon</Col>
                                <Col type='btn'>Botones</Col>
                        </Row>
                        <Row>
                                <Col>5</Col>
                                <Col>Texto de prueba d</Col>
                                <Col>1000</Col>
                                <Col>159753</Col>
                                <Col>
                                        <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="ellipsis" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                                            <path fill="currentColor" d="M120 256C120 286.9 94.93 312 64 312C33.07 312 8 286.9 8 256C8 225.1 33.07 200 64 200C94.93 200 120 225.1 120 256zM280 256C280 286.9 254.9 312 224 312C193.1 312 168 286.9 168 256C168 225.1 193.1 200 224 200C254.9 200 280 225.1 280 256zM328 256C328 225.1 353.1 200 384 200C414.9 200 440 225.1 440 256C440 286.9 414.9 312 384 312C353.1 312 328 286.9 328 256z"></path>
                                        </svg>
                                </Col>
                                <Col>
                                        <Button className="primary">Primary</Button>
                                        <Button className="caution">Caution</Button>
                                </Col>
                        </Row>
                        <Row>
                                <Col>4</Col>
                                <Col>Texto de prueba b</Col>
                                <Col>1000</Col>
                                <Col>597531</Col>
                                <Col>
                                        <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="ellipsis" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                                            <path fill="currentColor" d="M120 256C120 286.9 94.93 312 64 312C33.07 312 8 286.9 8 256C8 225.1 33.07 200 64 200C94.93 200 120 225.1 120 256zM280 256C280 286.9 254.9 312 224 312C193.1 312 168 286.9 168 256C168 225.1 193.1 200 224 200C254.9 200 280 225.1 280 256zM328 256C328 225.1 353.1 200 384 200C414.9 200 440 225.1 440 256C440 286.9 414.9 312 384 312C353.1 312 328 286.9 328 256z"></path>
                                        </svg>
                                </Col>
                                <Col>
                                        <Button className="primary">Primary</Button>
                                        <Button className="caution">Caution</Button>
                                </Col>
                        </Row>
                        <Row>
                                <Col>3</Col>
                                <Col>Texto de prueba a</Col>
                                <Col>4000</Col>
                                <Col>975315</Col>
                                <Col>
                                        <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="ellipsis" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                                            <path fill="currentColor" d="M120 256C120 286.9 94.93 312 64 312C33.07 312 8 286.9 8 256C8 225.1 33.07 200 64 200C94.93 200 120 225.1 120 256zM280 256C280 286.9 254.9 312 224 312C193.1 312 168 286.9 168 256C168 225.1 193.1 200 224 200C254.9 200 280 225.1 280 256zM328 256C328 225.1 353.1 200 384 200C414.9 200 440 225.1 440 256C440 286.9 414.9 312 384 312C353.1 312 328 286.9 328 256z"></path>
                                        </svg>
                                </Col>
                                <Col>
                                        <Button className="primary">Primary</Button>
                                        <Button className="caution">Caution</Button>
                                </Col>
                        </Row>
                        <Row>
                                <Col>2</Col>
                                <Col>Texto de prueba c</Col>
                                <Col>3000</Col>
                                <Col>753159</Col>
                                <Col>
                                        <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="ellipsis" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                                            <path fill="currentColor" d="M120 256C120 286.9 94.93 312 64 312C33.07 312 8 286.9 8 256C8 225.1 33.07 200 64 200C94.93 200 120 225.1 120 256zM280 256C280 286.9 254.9 312 224 312C193.1 312 168 286.9 168 256C168 225.1 193.1 200 224 200C254.9 200 280 225.1 280 256zM328 256C328 225.1 353.1 200 384 200C414.9 200 440 225.1 440 256C440 286.9 414.9 312 384 312C353.1 312 328 286.9 328 256z"></path>
                                        </svg>
                                </Col>
                                <Col>
                                        <Button className="primary">Primary</Button>
                                        <Button className="caution">Caution</Button>
                                </Col>
                        </Row>
                        <Row>
                                <Col>1</Col>
                                <Col>Texto de prueba e</Col>
                                <Col>5000</Col>
                                <Col>531597</Col>
                                <Col>
                                        <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="ellipsis" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                                            <path fill="currentColor" d="M120 256C120 286.9 94.93 312 64 312C33.07 312 8 286.9 8 256C8 225.1 33.07 200 64 200C94.93 200 120 225.1 120 256zM280 256C280 286.9 254.9 312 224 312C193.1 312 168 286.9 168 256C168 225.1 193.1 200 224 200C254.9 200 280 225.1 280 256zM328 256C328 225.1 353.1 200 384 200C414.9 200 440 225.1 440 256C440 286.9 414.9 312 384 312C353.1 312 328 286.9 328 256z"></path>
                                        </svg>
                                </Col>
                                <Col>
                                        <Button className="primary">Primary</Button>
                                        <Button className="caution">Caution</Button>
                                </Col>
                        </Row>
                </Table>
    );
}`;

    return (
        <Main>
            <div className="section elementos">
                <h5 className="c-green">Componentes</h5>
                <h2>Elementos</h2>

                <BoxCode title='Tabla' code={code}>
                    <Table>
                        <Row type='header'>
                            <Col priority='alta' type='number' order={true}>ID</Col>
                            <Col priority='alta' order={true} filter={[true, 'text', 'Buscar Palabra']} max={50}>Default (Texto)</Col>
                            <Col priority='media' type='numero' filter={[true]}>Numero</Col>
                            <Col type='money' size={200}>Money</Col>
                            <Col priority='media' type='icon'>Icon</Col>
                            <Col type='btn'>Botones</Col>
                        </Row>
                        <Row>
                            <Col>5</Col>
                            <Col>Texto de prueba d</Col>
                            <Col>1000</Col>
                            <Col>159753</Col>
                            <Col>
                                <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="ellipsis" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                                    <path fill="currentColor" d="M120 256C120 286.9 94.93 312 64 312C33.07 312 8 286.9 8 256C8 225.1 33.07 200 64 200C94.93 200 120 225.1 120 256zM280 256C280 286.9 254.9 312 224 312C193.1 312 168 286.9 168 256C168 225.1 193.1 200 224 200C254.9 200 280 225.1 280 256zM328 256C328 225.1 353.1 200 384 200C414.9 200 440 225.1 440 256C440 286.9 414.9 312 384 312C353.1 312 328 286.9 328 256z"></path>
                                </svg>
                            </Col>
                            <Col>
                                <Button className="primary">Primary</Button>
                                <Button className="caution">Caution</Button>
                            </Col>
                        </Row>
                        <Row>
                            <Col>4</Col>
                            <Col>Texto de prueba b</Col>
                            <Col>1000</Col>
                            <Col>597531</Col>
                            <Col>
                                <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="ellipsis" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                                    <path fill="currentColor" d="M120 256C120 286.9 94.93 312 64 312C33.07 312 8 286.9 8 256C8 225.1 33.07 200 64 200C94.93 200 120 225.1 120 256zM280 256C280 286.9 254.9 312 224 312C193.1 312 168 286.9 168 256C168 225.1 193.1 200 224 200C254.9 200 280 225.1 280 256zM328 256C328 225.1 353.1 200 384 200C414.9 200 440 225.1 440 256C440 286.9 414.9 312 384 312C353.1 312 328 286.9 328 256z"></path>
                                </svg>
                            </Col>
                            <Col>
                                <Button className="primary">Primary</Button>
                                <Button className="caution">Caution</Button>
                            </Col>
                        </Row>
                        <Row>
                            <Col>3</Col>
                            <Col>Texto de prueba a</Col>
                            <Col>4000</Col>
                            <Col>975315</Col>
                            <Col>
                                <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="ellipsis" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                                    <path fill="currentColor" d="M120 256C120 286.9 94.93 312 64 312C33.07 312 8 286.9 8 256C8 225.1 33.07 200 64 200C94.93 200 120 225.1 120 256zM280 256C280 286.9 254.9 312 224 312C193.1 312 168 286.9 168 256C168 225.1 193.1 200 224 200C254.9 200 280 225.1 280 256zM328 256C328 225.1 353.1 200 384 200C414.9 200 440 225.1 440 256C440 286.9 414.9 312 384 312C353.1 312 328 286.9 328 256z"></path>
                                </svg>
                            </Col>
                            <Col>
                                <Button className="primary">Primary</Button>
                                <Button className="caution">Caution</Button>
                            </Col>
                        </Row>
                        <Row>
                            <Col>2</Col>
                            <Col>Texto de prueba c</Col>
                            <Col>3000</Col>
                            <Col>753159</Col>
                            <Col>
                                <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="ellipsis" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                                    <path fill="currentColor" d="M120 256C120 286.9 94.93 312 64 312C33.07 312 8 286.9 8 256C8 225.1 33.07 200 64 200C94.93 200 120 225.1 120 256zM280 256C280 286.9 254.9 312 224 312C193.1 312 168 286.9 168 256C168 225.1 193.1 200 224 200C254.9 200 280 225.1 280 256zM328 256C328 225.1 353.1 200 384 200C414.9 200 440 225.1 440 256C440 286.9 414.9 312 384 312C353.1 312 328 286.9 328 256z"></path>
                                </svg>
                            </Col>
                            <Col>
                                <Button className="primary">Primary</Button>
                                <Button className="caution">Caution</Button>
                            </Col>
                        </Row>
                        <Row>
                            <Col>1</Col>
                            <Col>Texto de prueba e</Col>
                            <Col>5000</Col>
                            <Col>531597</Col>
                            <Col>
                                <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="ellipsis" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                                    <path fill="currentColor" d="M120 256C120 286.9 94.93 312 64 312C33.07 312 8 286.9 8 256C8 225.1 33.07 200 64 200C94.93 200 120 225.1 120 256zM280 256C280 286.9 254.9 312 224 312C193.1 312 168 286.9 168 256C168 225.1 193.1 200 224 200C254.9 200 280 225.1 280 256zM328 256C328 225.1 353.1 200 384 200C414.9 200 440 225.1 440 256C440 286.9 414.9 312 384 312C353.1 312 328 286.9 328 256z"></path>
                                </svg>
                            </Col>
                            <Col>
                                <Button className="primary">Primary</Button>
                                <Button className="caution">Caution</Button>
                            </Col>
                        </Row>
                    </Table>
                </BoxCode>
            </div>
        </Main>
    );
}